import type {InfiniteData, QueryKey} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import type {UnifiedFeedPage} from '@/types/conversationMessage';
import {unifiedMessagesQueryKey} from '@/hooks/queries/use-unified-messages/useUnifiedMessages';

export interface ConversationCacheSnapshot {
  queryKey: QueryKey;
  previousData: InfiniteData<UnifiedFeedPage>;
}

export function setFirstUnreadMessageId(
  conversationId: string,
  messageId: string,
  campaignId?: string
): ConversationCacheSnapshot | undefined {
  const queryKey = unifiedMessagesQueryKey(conversationId, campaignId);
  const previousData =
    queryClient.getQueryData<InfiniteData<UnifiedFeedPage>>(queryKey);

  queryClient.setQueryData<InfiniteData<UnifiedFeedPage>>(queryKey, (old) => {
    if (!old) return old;
    const [firstPage, ...rest] = old.pages;
    return {
      ...old,
      pages: [{...firstPage, firstUnreadMessageId: messageId}, ...rest],
    };
  });

  return previousData ? {queryKey, previousData} : undefined;
}

export function restoreUnifiedFeedCache(
  snapshot: ConversationCacheSnapshot | undefined
): void {
  if (!snapshot) return;
  queryClient.setQueryData(snapshot.queryKey, snapshot.previousData);
}
